import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {
  Text,
  View,
  StyleSheet,
  Platform,
} from 'react-native';
import {scale, moderateScale} from 'react-native-size-matters';
import { mappedTitles } from '../../WorkoutGoalAssistant';
import { connect } from 'react-redux';
import { SelectionContainer } from '../../Bookings/components/SelectionContainer';
import Theme from '../../theme';
import { Button } from '../../components';
import { genders, foodPreferences, unitPreferences } from '../../utils';
import { UserDataConsumer } from '../../utils';
import { ProgramType } from 'fitbeat.models';
import { savePreferences } from '../actions';

class MealPreferencesSettings extends Component {
  constructor(props) {
    super(props);
    const {user: { userProfile }} = this.props;
    const { useImperialUnit } = userProfile;
    this.state = { foodPreference: null, gender: null, useImperialUnit };
  }

  setFoodPreference = (foodPreference) => () => {
    this.setState({ foodPreference });
  }

  componentDidUpdate(previousProps){
    if ( !previousProps.user.userProfile.mealPreferences && this.props.user.userProfile.mealPreferences ) {
      this.props.navigation.navigate('NutritionTabs');
    }
  }

  savePreferences = () => {
    const { gender, foodPreference, useImperialUnit } = this.state;
    const goal =
      this.props.user.userProfile.longTermGoal ||
      ProgramType.GetStrongAndFitGoal;
    this.props.savePreferences(foodPreference, useImperialUnit, goal, gender);
  }

  setUseImperialUnit = () => {
    this.setState({ useImperialUnit: !this.state.useImperialUnit });
  }

  render() {
    const { t } = this.props;
    const {user: { userProfile: { longTermGoal = ProgramType.GetLeanAndFitGoal } }} = this.props;
    const boxHeight = moderateScale(65);

    const buttonSize = moderateScale(50);
    return (
      <View style={{flex: 1, padding: 15, backgroundColor: Theme.WHITE}}>
      <Text style={styles.setPreferenceTextStyle}>
          {t('nutrition:setPreferences')}
          <Text style={styles.boldText}>{mappedTitles[ProgramType[longTermGoal]]} </Text>
          {t('nutrition:recepiesAndShoppingLists')}
        </Text>
      <View style={styles.container}>
        <View style={{marginTop: scale(15), marginBottom: scale(10)}} >
          <Text style={styles.choiceHeader}>PREFERENCE</Text>
          <View style={styles.choiceContainer}>
            {foodPreferences.map((foodPreferenceItem, index) => {
              return (
                <SelectionContainer
                  title={foodPreferenceItem.display}
                  onPress={this.setFoodPreference(foodPreferenceItem.value)}
                  height={boxHeight}
                  isSelected={
                    foodPreferenceItem.value === this.state.foodPreference
                  }
                  style={{
                    flex: 1,
                    marginRight: index === foodPreferences.length - 1 ? 0 : 20,
                  }}
                  titleStyle={styles.choiceTitleStyle}
                />
              );
            })}
          </View>
        </View>
        <View style={{marginVertical: scale(10)}}>
          <Text style={styles.choiceHeader}>GENDER</Text>
          <View style={styles.choiceContainer}>
            {genders.map((genderItem, index) => {
              return (
                <SelectionContainer
                  title={genderItem.display}
                  onPress={() => {
                    this.setState({ gender: genderItem.value });
                  }}
                  height={boxHeight}
                  isSelected={genderItem.value === this.state.gender}
                  style={{
                    flex: 1,
                    marginRight: index === genders.length - 1 ? 0 : 10,
                  }}
                  titleStyle={styles.choiceTitleStyle}
                />
              );
            })}
          </View>
        </View>
        <View style={{marginVertical: scale(10)}}>
          <Text style={styles.choiceHeader}>MEASUREMENT UNITS</Text>
          <View style={styles.choiceContainer}>
            {unitPreferences.map((unitPreferenceItem, index) => {
              return (
                <SelectionContainer
                  title={unitPreferenceItem.display}
                  onPress={() => {
                    this.setState({
                      useImperialUnit: unitPreferenceItem.useImperialUnit,
                    });
                  }}
                  height={boxHeight}
                  isSelected={
                    this.state.useImperialUnit ===
                    unitPreferenceItem.useImperialUnit
                  }
                  style={{
                    flex: 1,
                    marginRight: index === foodPreferences.length - 1 ? 0 : 20,
                  }}
                  titleStyle={styles.choiceTitleStyle}
                />
              );
            })}
          </View>
        </View>
      </View>
        <Button
          fontColor={Theme.WHITE}
          fontSize={moderateScale(20)}
          isLoading={this.props.isLoading}
          title='Save'
          onPress={this.savePreferences}
          disabled={!this.state.gender || this.state.useImperialUnit === undefined || !this.state.foodPreference}
          containerStyle={{ height: buttonSize, borderRadius: 5}}
        />
      </View>
    );
  }
}
MealPreferencesSettings.propTypes = {};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...Platform.select({
      web: {
        height: '100vh',
      },
    }),
  },
  choiceContainer: {
    flexDirection: 'row',
  },
  choiceHeader: {
    fontSize: moderateScale(15),
    fontWeight: 'bold',
    fontFamily: Theme.Custom700,
    marginBottom: 6,
    color: Theme.GREY_DARK,
  },
  selectionContainer: {
    flex: 1,
    marginLeft: 10,
  },
  choiceTitleStyle: {
    paddingTop: 0,
    lineHeight: moderateScale(15),
    fontSize: moderateScale(15),
  },
  boldText: {
    fontWeight: 'bold',
  },
  setPreferenceTextStyle: {
    fontSize: moderateScale(23),
    paddingTop: 10,
    color: Theme.GREY_DARK,
  },
});

const mapStateToProps = (state) => {
  const { nutrition: {isLoading}} = state;
  return {
    isLoading,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { user: { nutritionService } } = ownProps;
  return {
      savePreferences: (foodPreference, useImperialUnit, dietGoal, gender) => {
          dispatch(savePreferences(nutritionService, foodPreference, useImperialUnit, dietGoal, gender));
      },
  };
};
MealPreferencesSettings = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(MealPreferencesSettings));
export default translate(['nutrition'], { wait: true })(
  MealPreferencesSettings,
);
